import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const navigation = inject(NavigationService);

  if (authService.isTokenValid()) {
    return true;
  } else {
    navigation.goToLogin();
    return false;
  }
};
